function getCookieByName(name: string): string | undefined {
   if (import.meta.env.SSR) return undefined;

   const cookies = document?.cookie.split(";");
   for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const [cookieName, cookieValue] = cookie.split("=").map((c) => c.trim());
      if (cookieName === name) {
         return decodeURIComponent(cookieValue);
      }
   }
   return undefined; // Return undefined if the cookie is not found
}

// Set the cookie
// - The cookie will be overwritten if it already exists
// - If you dont set a daysToExpire value, the cookie will expire at the end of the session (when the browser closes)
function setCookie(name: string, value: string, daysToExpire?: number) {
   let expires = "";
   if (daysToExpire) {
      const date = new Date();
      date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
   }
   // note that we add the domain to ensure that the cookie is unique across all portal domains and subdomains
   document.cookie = `${name}=${encodeURIComponent(value)}${expires}; domain=${window.location.hostname}; path=/`;
}

export { getCookieByName, setCookie };
